import { Link } from "react-router-dom";

export function CheckoutCancel() {
  return (
    <div className="mx-auto max-w-lg">
      <div className="rounded-2xl border border-line bg-surface p-8 text-center shadow-card">
        <h1 className="text-2xl font-extrabold tracking-tight text-ink">Checkout canceled</h1>
        <p className="mt-2 text-ink-soft">
          No charge was made. Your cart is still saved if you'd like to try again.
        </p>
        <div className="mt-5 flex justify-center gap-3">
          <Link
            to="/cart"
            className="rounded-lg bg-brand px-4 py-2 font-semibold text-white hover:bg-brand-strong"
          >
            Back to cart
          </Link>
          <Link
            to="/"
            className="rounded-lg border border-line px-4 py-2 font-medium text-ink-soft hover:text-ink hover:border-line-strong"
          >
            Catalog
          </Link>
        </div>
      </div>
    </div>
  );
}
